import useDispatchify from 'common/hooks/utils/useDispatchify';
import useJiraSetupStates from '../hooks/useJiraSetupStates';
import { Step2, Step3 } from '../JiraConnectSteps';
import Text from 'components/base/Text';
import { Flex, Separator } from 'components/base/layout-components';
import { verticalScroller } from 'components/base/scroller';
import styled from 'styled-components';
import { toggleModal as toggleModalCaller } from 'state/callers';
import { LBJiraIcon } from '@linearb/buzz';

const VerticalLine = styled(Separator)`
  margin-left: -2rem;
  width: calc(100% + 4rem);
  margin-bottom: 2rem;
`;

const HTTPS_REGEX = /(^\w+:|^)\/\//;

const Title = props => {
  return (
    <Flex items='center' {...props}>
      <LBJiraIcon className='size-5 mr-2' />
      <Text size='x-large'>Reauthorize Jira</Text>
      {props.url && (
        <Flex items='center'>
          <Separator margin='0 1rem' />
          <Text>{props.url.replace(HTTPS_REGEX, '')}</Text>
        </Flex>
      )}
    </Flex>
  );
};

const ScrolledContainer = styled(Flex)`
  ${verticalScroller()};
  max-height: 90rem;
`;

const JiraReauthModal = () => {
  const toggleModal = useDispatchify(toggleModalCaller);
  const jiraSetupStates = useJiraSetupStates();

  const { customer_key, shared_secret, rsa_public_key } =
    jiraSetupStates.authKeys as any;

  return (
    <Flex direction='column'>
      <Title pt='medium' pl='medium' url={jiraSetupStates.baseJiraUrl} />
      <ScrolledContainer direction='column' padding='medium'>
        {!jiraSetupStates.finish && (
          <Step2
            disabled={false}
            onContinue={jiraSetupStates.onStep2Finish}
            jiraBaseURL={jiraSetupStates.baseJiraUrl}
            consumerKey={customer_key}
            sharedSecret={shared_secret}
            publicKey={rsa_public_key}
            withTitle={false}
            reauthorize={true}
            separator={<VerticalLine height='1px' />}
          />
        )}
        {jiraSetupStates.finish && (
          <Step3
            reauthorize={true}
            onFinish={async () => {
              await jiraSetupStates.onStep3Finish();
              toggleModal();
            }}
          />
        )}
      </ScrolledContainer>
    </Flex>
  );
};

export default JiraReauthModal;
